import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import { green } from 'globals/colors';
import { FsComponentSize, TypographyAllProps } from 'globals/types';
import FsBody from 'ui-elements/typography/FsBody';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

interface Size {
  size?: FsComponentSize.M | FsComponentSize.S;
}

export const NameBox = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
}))(Box);

export const ContentBox = withStyles(({ spacing }) => ({
  root: {
    marginLeft: spacing(1.5),
    marginRight: spacing(1),
  },
}))(({ size, ...otherProps }: BoxProps & Size) => (
  <Box
    {...otherProps}
    style={{
      marginLeft: 6,
      marginRight: 6,
    }}
  />
));

export const Name = withStyles(() => ({
  root: {},
}))(({ size, ...otherProps }: TypographyAllProps & Size) => (
  <FsBody
    {...otherProps}
    style={{ fontSize: size === FsComponentSize.S ? 12 : undefined }}
  />
));

export const SubContent = withStyles(({ palette }) => ({
  root: {
    color: palette.grey[400],
  },
}))(FsBodySmall);

export const Avatar = withStyles(({ spacing }) => ({
  root: {
    width: spacing(5),
    minWidth: spacing(5),
    height: spacing(5),
    overflow: 'hidden',
    background: green.V2,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(({ color, size, ...otherProps }: BoxProps & { color?: string } & Size) => (
  <Box
    {...otherProps}
    style={{
      background: color || undefined,
      width: size === FsComponentSize.S ? 20 : undefined,
      minWidth: size === FsComponentSize.S ? 20 : undefined,
      height: size === FsComponentSize.S ? 20 : undefined,
    }}
  />
));
